import { api } from '../main-api/apiClient';

// Tenant Admin API services - for tenant administration and management
export const tenantAdminAPI = {
  // Tenant Information
  getTenantInfo: () => api.get('/tenant-admin/tenant/info'),
  
  updateTenant: (tenantData) => {
    const formData = new FormData();
    Object.keys(tenantData).forEach(key => {
      if (tenantData[key] !== null && tenantData[key] !== undefined && tenantData[key] !== '') {
        formData.append(key, tenantData[key]);
      }
    });
    return api.put('/tenant-admin/tenant', formData);
  },
  
  // User Management within Tenant
  getUsers: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/tenant-admin/users?${queryString}`);
  },
  
  createUser: (userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined && userData[key] !== '') {
        formData.append(key, userData[key]);
      }
    });
    return api.post('/tenant-admin/users', formData);
  },
  
  updateUser: (userId, userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined && userData[key] !== '') {
        formData.append(key, userData[key]);
      }
    });
    return api.put(`/tenant-admin/users/${userId}`, formData);
  },
  
  deleteUser: (userId) => api.delete(`/tenant-admin/users/${userId}`),
  
  // Patient Management within Tenant
  getPatients: () => api.get('/tenant-admin/patients'),
  
  createPatient: (patientData) => {
    console.log('=== TENANT ADMIN API: createPatient START ===');
    console.log('tenantAdminAPI: Received patient data:', patientData);
    console.log('tenantAdminAPI: Data type:', typeof patientData);
    console.log('tenantAdminAPI: Data keys:', Object.keys(patientData));
    
    const formData = new FormData();
    Object.keys(patientData).forEach(key => {
      if (patientData[key] !== null && patientData[key] !== undefined && patientData[key] !== '') {
        formData.append(key, patientData[key]);
        console.log(`tenantAdminAPI: Added to FormData - ${key}:`, patientData[key]);
      } else {
        console.log(`tenantAdminAPI: Skipped empty field - ${key}:`, patientData[key]);
      }
    });
    
    console.log('tenantAdminAPI: FormData created with entries:');
    for (let [key, value] of formData.entries()) {
      console.log(`  ${key}: ${value}`);
    }
    
    console.log('tenantAdminAPI: About to call api.post("/patients", formData)');
    console.log('tenantAdminAPI: API base URL should be from apiClient config');
    
    const result = api.post('/patients', formData);
    console.log('tenantAdminAPI: API call initiated, result:', result);
    console.log('=== TENANT ADMIN API: createPatient END ===');
    
    return result;
  },

  updatePatient: (patientId, patientData) => {
    const formData = new FormData();
    Object.keys(patientData).forEach(key => {
      if (patientData[key] !== null && patientData[key] !== undefined && patientData[key] !== '') {
        formData.append(key, patientData[key]);
      }
    });
    return api.put(`/patients/${patientId}`, formData);
  },
  
  // Recording Management (tenant admins can also send recording links)
  sendRecordingLink: (patientId, channel, customMessage = null) => {
    const formData = new FormData();
    formData.append('channel', channel);
    if (customMessage) {
      formData.append('custom_message', customMessage);
    }
    return api.post(`/tenant-admin/patients/${patientId}/send-recording-link`, formData);
  },
  
  // Analytics and Reporting
  getAnalyticsSummary: () => api.get('/tenant-admin/analytics/summary'),
  
  // Tenant Settings
  updateTenantSettings: (settings) => {
    return api.put('/tenant-admin/settings', settings);
  },

  // Scheduling Management
  getSchedules: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/tenant-admin/schedules?${queryString}`);
  },

  createSchedule: (scheduleData) => {
    const formData = new FormData();
    Object.keys(scheduleData).forEach(key => {
      if (scheduleData[key] !== null && scheduleData[key] !== undefined && scheduleData[key] !== '') {
        formData.append(key, scheduleData[key]);
      }
    });
    return api.post('/tenant-admin/schedules', formData);
  },

  updateSchedule: (scheduleId, scheduleData) => {
    const formData = new FormData();
    Object.keys(scheduleData).forEach(key => {
      if (scheduleData[key] !== null && scheduleData[key] !== undefined && scheduleData[key] !== '') {
        formData.append(key, scheduleData[key]);
      }
    });
    return api.put(`/tenant-admin/schedules/${scheduleId}`, formData);
  },

  deleteSchedule: (scheduleId) => api.delete(`/tenant-admin/schedules/${scheduleId}`),
  
  // Patient Vitals Management
  getPatientVitals: (patientId) => api.get(`/patients/${patientId}/vitals`),

  // Scheduling API methods
  scheduleRecordingEmail: (scheduleData) => {
    const formData = new FormData();
    formData.append('patient_id', scheduleData.patient_id);
    formData.append('scheduled_date', scheduleData.scheduled_date);
    formData.append('scheduled_time', scheduleData.scheduled_time);
    formData.append('title', scheduleData.title);
    if (scheduleData.description) formData.append('description', scheduleData.description);
    if (scheduleData.notes) formData.append('notes', scheduleData.notes);
    
    return api.post('/scheduling/schedule-recording-email', formData);
  },

  getScheduledEmails: (patientId = null) => {
    const params = patientId ? `?patient_id=${patientId}` : '';
    return api.get(`/scheduling/scheduled-emails${params}`);
  },

  cancelScheduledEmail: (jobId) => {
    return api.delete(`/scheduling/cancel-scheduled-email/${jobId}`);
  },

  rescheduleEmail: (jobId, newDate, newTime) => {
    const formData = new FormData();
    formData.append('new_date', newDate);
    formData.append('new_time', newTime);
    
    return api.put(`/scheduling/reschedule-email/${jobId}`, formData);
  },

  // Auth0 User Management (new endpoints)
  createUserWithAuth0: (userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined && userData[key] !== '') {
        formData.append(key, userData[key]);
      }
    });
    return api.post('/tenant-admin/users/create-with-auth0', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  sendMfaEnrollment: (userId) => {
    return api.post(`/tenant-admin/users/${userId}/send-mfa-enrollment`);
  },
  
  resendPasswordSetup: (userId) => {
    return api.post(`/tenant-admin/users/${userId}/resend-password-setup`);
  },

  // Twilio Voice Calling
  initiatePatientCall: (patientId) => {
    return api.post(`/patients/${patientId}/initiate-call`);
  },

  // ✨ NEW: Twilio Call Recording Vitals API Methods
  
  // Get latest call recording vitals for a patient (for Eye button)
  getPatientCallVitals: (patientId) => {
    return api.get(`/twilio-vitals/patient/${patientId}/latest-vitals`);
  },

  // Get all call recordings for a patient
  getPatientCallRecordings: (patientId, limit = 10) => {
    return api.get(`/twilio-vitals/patient/${patientId}/call-recordings?limit=${limit}`);
  },

  // Manually process a Twilio recording
  processRecording: (recordingData) => {
    return api.post('/twilio-vitals/process-recording', recordingData);
  },

  // Manual process by recording SID
  manualProcessRecording: (recordingSid, patientId) => {
    return api.post('/twilio-vitals/manual-process', {
      recording_sid: recordingSid,
      patient_id: patientId
    });
  },

  // Get processor status for debugging
  getTwilioVitalsStatus: () => {
    return api.get('/twilio-vitals/status');
  },

  // Delete a call recording
  deleteCallRecording: (patientId, recordingId) => {
    return api.delete(`/twilio-vitals/patient/${patientId}/recordings/${recordingId}`);
  }
};

export default tenantAdminAPI;